module.exports = __webpack_public_path__ + "img/Survey-Form_Freedom-concept-2021.4e691745.png";